import React from "react";
import { Link } from "react-router-dom";
import gif from "../../../assets/gif.gif";
const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="rbs-bottom-page-wrapper">
      <div className="row">
        <div className="col-12 col-md-9">
          <h4 className="title_text">
            Revolutionize Inventory Management with RFID and Barcode Solutions
          </h4>
          <p className="contact_investers_para">
            At Soori Corporation, we go beyond traditional tracking; we empower
            your operations with innovative RFID and barcode technologies. Our
            solutions streamline processes, enhance accuracy, and provide
            real-time insights, ensuring your business stays ahead in a
            competitive landscape.
          </p>
          <Link
            to="/connect-with-us"
            className="btn-md btn-dark border-0"
            onClick={() => scrollHeader()}
          >
            Transform Your Tracking Today
          </Link>
        </div>
        <div className="col-12 col-md-3">
          <div className="circle-gif">
            <img src={gif} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
